<template>
  <div>
    <div class="search">
      <div class="div-text">
        <p class="text">Buscar un Servicio</p>
      </div>
      <div class="input-icono">
        <input v-model="toSearch" type="text" name="input" />
        <b-button class="btn class"><p class="text-btn">Buscar</p></b-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      toSearch: ""
    }
  },
  props: ["modifyInput"],
  watch: {
    toSearch: function() {
      this.modifyInput(this.toSearch);
    }
  }
}
</script>
<style scoped>
.search {
  display: flex;
  justify-content: flex-end;
}

.input-icono {
  background-color: white;
  background-image: url("../../assets/img/input/bx-search-alt.svg");
  background-repeat: no-repeat;
  background-position: 4px center;
  background-size: 20px;
  display: flex;
  align-items: center;
  width: 250px;
  padding-left: 28px;
  height: 30px;
  border: 1px solid rgb(5, 35, 51);
  border-radius: 20px;
}
.input-icono input {
  width: 100%;
  font-size: 0.9em;
  border: none;
}
.input-icono input:focus {
  outline: none;
}

.btn {
  height: 30px;
  background: #052333;
  border-radius: 0;
  border-top-right-radius: 13px;
  border-bottom-right-radius: 13px;
}

.class {
  padding: 0 0.7rem !important;
}

.text {
  color: #052333;
  font-size: 13px;
  margin-top: 6px;
}

.text-btn {
  font-weight: 200;
  font-size: 0.8rem;
}
</style>
